<div class="page-container account-review-container container pb-3">
  <app-breadcrumb [crumbConfig]="crumbConfig" />

  @if (accountId === '') {
    <app-rb-grid
      [gridConfig]="gridConfig"
      [getSetup]="getGridSetup"
      [getData]="getGridData"
    />
  } @else {
    <app-account-review-detail [accountId]="accountId" />
  }
</div>
